var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "formList",
          rowId: _vm.rowId,
          "pager-config": _vm.pagerConfig,
          "form-config": _vm.formConfig,
          url: _vm.url,
          columns: _vm.columns,
          "checkbox-config": _vm.checkboxConfig,
          "toolbar-config": _vm.toolbarConfig,
          "print-config": _vm.printConfig,
          "import-config": _vm.importConfig,
          "export-config": _vm.exportConfig,
          "cell-click": _vm.chooseRow,
          cellDbClick: _vm.updateRow,
        },
        on: { "toolbar-addData": _vm.addRow, "toolbar-delData": _vm.delRow },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.toolbarConfig.templatelSlots,
              fn: function () {
                return undefined
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "a-modal",
        {
          attrs: {
            title: "工作流配置",
            centered: "",
            footer: null,
            maskClosable: false,
            closable: true,
            visible: _vm.editModalVisible,
            width: 1000,
          },
          on: { cancel: _vm.closeEdit },
        },
        [
          _vm.editModalVisible
            ? _c("formDetail", {
                ref: "detailForm",
                attrs: { rowId: _vm.editRowId },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeEdit()
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }